export const iconFontAwesomeScienceFilter = (
	<i className="fa-solid fa-filter"></i>
);
